import update from 'immutability-helper';
import { createCase, createSwitch } from 'helpers/action-helpers';
import { initialState as initialScannerState } from './state';
import { initialState as initialMainState } from 'components/main/state';
import { SetAlertsAction } from 'components/main/actions';

export const scannerReducer = createSwitch(initialScannerState, [
  createCase(new SetAlertsAction(initialMainState.alerts), (state, action) => {
    return update(state, { isEnabled: { $set: action.alerts.length === 0} });
  })
]);


// WEBPACK FOOTER //
// ./src/components/scanner/reducer.ts